// extracted by mini-css-extract-plugin
export var container = "_5r-1";
export var cornerButtonContainer = "_5r-5";
export var disabled = "_5r-2";
export var fileContainer = "_5r-4";
export var hiddenInput = "_5r-3";
export var widthContainer = "_5r-0";